
<template> 
    <v-card>
        <v-toolbar dark color="primary">
            <v-btn  icon dark :disabled="submitLoading" @click="close()">
                <v-icon large>close</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-toolbar-title>
                <span v-if="editData.CropWorkDepartmentCodeID > 0">Edit Department Code</span>
                <span v-else>Add New Department Code</span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-form ref="editForm" v-model="editValid">
            <v-layout class="dialog-content">
                <v-flex xs12 md10 offset-md1 mt-4>
                    <v-layout wrap>
                        <v-flex xs12>
                            <v-text-field label="Activity Department Code" ref="ActivityDepartmentCodeField" v-model="editData.ActivityDepartmentCode" counter="25" :rules="codeRules"></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field label="Description" v-model="editData.Description" counter="100" :rules="requiredRule"></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-layout wrap class="dialog-action-buttons">
                        <v-flex xs12>
                            <v-select :items="productCategories" 
                                v-model="editData.ProductCategories" 
                                item-value="ProductCategoryID" 
                                item-text="ProductCategoryName" 
                                label="Product Categories" 
                                :rules="requiredRule" 
                                return-object
                                multiple>
                                    <v-btn slot="prepend-item" color="primary" @click="selectAllProductCategories">Select all</v-btn>
                                    <v-divider slot="prepend-item" class="mt-2"/>
                                </v-select>
                        </v-flex>
                        <v-flex xs12>
                            <v-select :items="divisions" v-model="editData.Divisions" item-value="DivisionID" item-text="DivisionName" label="Divisions" multiple return-object :rules="requiredRule" clearable>
                                <v-btn slot="prepend-item" color="primary" @click="selectAllDivisions">Select all</v-btn>
                                <v-divider
                                    slot="prepend-item"
                                    class="mt-2"/>
                                </v-select>
                        </v-flex>
                    </v-layout>
                    <v-layout wrap class="dialog-action-buttons">
                        <v-flex xs12 sm6>
                            <v-btn block color="success" :disabled="!editValid" :loading="submitLoading" @click="submit">
                                <span>Save</span>
                            </v-btn>
                        </v-flex>
                        <v-flex xs12 sm6>
                            <v-btn block color="error" :disabled="submitLoading" @click="close()">
                                <span>Cancel</span>
                            </v-btn>
                        </v-flex>
                        <v-flex xs12>
                            <v-alert :value="error != null" outline type="error">
                                <span>{{ error }}</span>
                            </v-alert>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-form>
    </v-card>
</template>

<script>

import {
    mapState
} from 'vuex';
import cropworkActivityApi from '@/api/cropworkActivityApi'

export default {
    components: {
    },
    props: [    
        'loading',
        'editData'
    ],
    data(){
        return {
            //rules: validationRules.rules,
            editValid: false,
            index: 0,
            error: null,
            submitLoading: false,
            codeRules: [v => v.length <= 25 || 'Max 25 characters', v => v.length > 0 || 'Required'],
            requiredRule: [v => v.length > 0 || 'Required']
        }
    },
    computed: {
        ...mapState("CropWorkStore", [
            "divisions",
            "productCategories"
        ]),
        plantID() {
            return this.$route.params.plantID;
        }
    },
    created() {
        // set focus on the first field 
        this.$nextTick(()=>{
            // wait for next tick so references are mapped & not undefined
            this.$refs.ActivityDepartmentCodeField.focus();
        });
    },
    methods: {
        close(){
            this.error = null; 
            this.$emit("close");
        },
        async submit(){
            // this.$emit("submit", this.editData);
            try {
                this.submitLoading=true
                // Save and finish
                var data = this.editData;
                
                const res = await cropworkActivityApi.saveDepatmentCode(data);
                console.log(res);
                if(res.Success){
                    //get updated data and dismiss dialog
                    this.close();
                    await this.$store.dispatch("CropWorkStore/loadActivityDepartmentCodesAsync", { plantID: this.plantID });
                }
                else {
                    // display error msg
                    this.error = res.ErrorMessages.join(', '); 
                }
            } 
            catch(e) {
                this.error = e;
            }
            finally {
                this.submitLoading = false;
            }
        },
        selectAllDivisions() {
            this.editData.Divisions = this.divisions;
        }
        ,selectAllProductCategories() {
            this.editData.ProductCategories = this.productCategories;
        }
    }
}
</script>